import React from "react";

const base = "w-full rounded-md border border-input bg-background px-3.5 py-2.5 text-sm focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none transition-shadow placeholder:text-muted-foreground";

export function Field({ label, children }) {
  return (
    <label className="block">
      {label && <span className="block text-sm font-medium mb-1.5">{label}</span>}
      {children}
    </label>
  );
}

export function Input({ testid, ...props }) {
  return <input data-testid={testid} className={base} {...props} />;
}

export function Textarea({ testid, ...props }) {
  return <textarea data-testid={testid} className={`${base} min-h-[120px] resize-y`} {...props} />;
}

export function Select({ testid, children, ...props }) {
  return <select data-testid={testid} className={base} {...props}>{children}</select>;
}
